import { BUYER_DATA } from "../constants/action-types";
import { uploadActions } from "./base-upload-reducers";

export const buyerDataUpload = uploadActions(BUYER_DATA);
